export class SurveyAggregateQuestionValue {
  public description: string;
  public rank: number;
  public value: number;
  public percentage: number;
  static parse(data: any): SurveyAggregateQuestionValue {
    let value = new SurveyAggregateQuestionValue();
    Object.assign(value, data);
    return value;
  }
}
